import { cn } from '@/utils/tailwind';
import { PropsWithChildren } from 'react';

export const DashboardCard = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  return <div className={cn(' space-y-3 rounded-[16px] bg-white p-5', className)}>{children}</div>;
};
